export default __webpack_public_path__ + "static/media/no_view_alert.e16239fa.svg";